import "./about.css"

import Container from "react-bootstrap/esm/Container";

import TitleBar from "../../../components/TitleBar";
import BottomBar from "../../../components/BottomBar";
import { consentUrl } from "../../Inquiry/urls";

const headline = (
  <>
    <div className="headline">
      <h3>ASEBIについて</h3>
      <h4><div className="en">About ASEBI</div></h4>
      <p>
        ASEBIとは、Archives of Shakingtable Experimentation dataBase and Informationの略で、<a href="https://e-defense.bosai.go.jp/">Ｅ－ディフェンス</a>を用いた実験で得られたデータを公開しています。<br />
        <div className="en">
          ASEBI is an abbreviation for Archives of Shakingtable Experimentation dataBase and Information, which publishes data obtained from experiments using E- Defense.
        </div>
      </p>
    </div>
  </>
);

const howToStart = (
  <>
    <h3>利用方法</h3>
    <h4><div className="en">Usage Rules</div></h4>
    <p>
      ASEBIの利用にはアカウント申請が必要です。詳しくは<a href={consentUrl('account')}>新規アカウント申請</a>のページをご覧ください。
      <div className="en">An account application is required to use ASEBI. Please see the Application for a New Account page for details.</div>
    </p>
    <p>
      ASEBIのデータを論文や研究発表等にデータを使用する場合には、各実験に付与されたDOIを引用してください。
      <div className="en">When using ASEBI data in papers or research publications, please cite the DOI assigned to each experiment.</div>
    </p>
  </>
);

const message = (
  <>
    <h3>さらに大きな研究コミュニティ創出を期待して</h3>
    <h4><div className="en">With Expectation of Creation of Even Larger Research Community</div></h4>
    <p>Ｅ－ディフェンスは、世界最高性能で世界最大のユニークな震動台ですが、その規模故、行われる実験ケースにも限りがあり、また、関わりたいと思われるすべての研究者が関われない可能性があります。 そのため、Ｅ－ディフェンスの建設計画の段階から、実験データの公開を望む声がありました。<br />
      <div className="en">E-Defense is the world's largest and most advanced unique seismic experimental facility, but due to its scale, there are limitations to the types of experiments that can be conducted, and it may not be possible for all researchers who wish to participate to do so. For this reason, there have been requests for the public release of experimental data since the planning stage of E-Defense.</div>
    </p>

    <p>
      実験データ公開の基本的な考え方は、実大三次元震動破壊実験施設運営協議会が、平成１７年３月３１日にとりまとめた「実大三次元震動破壊実験施設 (Ｅ－ディフェンス)運営・利用のあり方について」 （理事長諮問：15防災特定第94号）に対する答申に謳われ、『「より多くの人が実験データを使えるほうが良い成果が出る」という実験データの有効活用、データの公開そのものがＥ－ディフェンスの地震工学分野への貢献と考えると 「実験データの公開」を原則とすることは重要であり、そのためのデータベースと国内外の研究機関などからアクセスできる利用システムの構築を、その運用体制の検討と共に推進する必要がある』と提言がなされました。<br />
      <div className="en">
        The basic approach to the disclosure of experimental data is outlined in the report titled “Guidelines for the Operation and Utilization of the Three-Dimensional Full-Scale Earthquake Testing Facility (E-Defense)” compiled by the Council for the Operation of the Three-Dimensional Full-Scale Earthquake Testing Facility on March 31, 2005 (Consultation with the President: 15 Disaster Prevention Specific No. 94) and states that, “Considering that the effective utilization of experimental data, such as ‘the more people who can use experimental data, the better the results,’ and the disclosure of data itself contribute to the field of earthquake engineering at E-Defense, it is important to establish the principle of ‘disclosure of experimental data.’ Therefore, it is necessary to promote the construction of a database and an access system for domestic and international research institutions, along with the consideration of operational systems.”
      </div>
    </p>
    <p>
      すなわち、Ｅ－ディフェンスによる実験データがデータベースとして公開されることにより、多くの研究者・技術者が、実験結果を様々な切り口から研究し、 個別の研究成果にとどまらず、より大きな成果の創出が期待されます。また、データ公開により、実験参加者のみならず、それ以外の方々も含めたより大きな研究コミュニティの創出が期待されます。<br />
      <div className="en">
        In other words, by making the experimental data obtained through E-Defense publicly available in the database, many researchers and engineers will be able to study the experimental results from various perspectives, leading not only to individual research achievements but also to the creation of greater results. Furthermore, the public release of data is expected to foster the creation of a larger research community that includes not only experimental participants but also others.
      </div>
    </p>
    <p>
      しかし一方で、実験を計画・実施する側に対しては、実験を遂行しその研究成果を公表すためのある一定期間の猶予を確保することも必要です。 これらのことも勘案して当研究所は、データ公開までに、実験終了後一定の猶予期間を設けることとしています。<br />
      <div className="en">
        However, on the other hand, it is also necessary to allow those planning and conducting experiments a certain period to complete their experiments and publish their findings. Taking these factors into consideration, our institute has decided to allow a certain period after the completion of experiments before data is made public.
      </div>
    </p>
    <p>
      データ公開システムがより有効に活用されることにより、研究者コミュニティが創出され、その研究成果が都市・地域の地震防災・減災に効果的に結びつけられることを切に願う次第です。
      <div className="en">
        We sincerely hope that the more effective use of data disclosure systems will foster a community of researchers and enable their research results to be effectively linked to earthquake disaster prevention and mitigation in cities and regions.
      </div>
    </p>
  </>
)

const About = () => {
  return (
    <>
      <TitleBar />
      <Container>
        <div className="container">
          {headline}
          {howToStart}
          {message}
        </div>
      </Container>
      <BottomBar />
    </>
  );
};

export default About;